import { Injectable } from '@angular/core';
import { AsyncValidatorFn, ValidationErrors, ValidatorFn } from '@angular/forms';
import { defaultIfEmpty, forkJoin, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class FieldWarningService {
  validateWarning(
    control: any,
    asyncValidatorFns: AsyncValidatorFn[],
    validatorFns: ValidatorFn[],
  ): Observable<ValidationErrors | null> {
    const results$ = [];
    for (const validatorFn of asyncValidatorFns) {
      results$.push(validatorFn(control));
    }
    return forkJoin(results$).pipe(
      defaultIfEmpty(null),
      map((results) => {
        let validationErrors: ValidationErrors = {};
        if (!results) {
          return null;
        }
        // adds asynchronous validators
        for (const err of results) {
          validationErrors = { ...validationErrors, ...err };
        }
        // adds synchronous validators
        for (const validatorFn of validatorFns) {
          const result = validatorFn(control);
          if (result) {
            validationErrors = { ...validationErrors, ...result };
          }
        }
        return validationErrors;
      }),
    );
  }
}
